import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { ArrowRight, Building2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import PageTransition from './PageTransition';

const ProductAdvisor = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageTransition type="door" productName="Virtual Business Policy Adviser" productColor="#8B3A3A">
      <div className="min-h-screen bg-white">
        <Header />
        
        {/* Hero Section */}
        <div className="relative pt-32 pb-20 bg-gradient-to-br from-slate-50 via-white to-red-50 overflow-hidden">
          <div className="absolute inset-0 opacity-5">
            <div className="absolute inset-0" style={{
              backgroundImage: 'radial-gradient(circle at 2px 2px, #8B3A3A 1px, transparent 0)',
              backgroundSize: '40px 40px'
            }}></div>
          </div>

          <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
            <div className={`text-center mb-12 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
              <div className="inline-flex items-center gap-2 bg-gradient-to-r from-[#8B3A3A]/10 to-[#6B2A2A]/10 backdrop-blur-sm px-6 py-3 rounded-full border border-[#8B3A3A]/20 mb-6">
                <Building2 className="w-5 h-5 text-[#8B3A3A]" />
                <span className="text-sm font-bold text-slate-700">Enterprise Solutions</span>
              </div>

              <h1 className="text-5xl md:text-7xl font-black text-slate-900 mb-6 tracking-tight">
                Virtual Business<br />Policy Adviser
              </h1>

              <p className="text-xl md:text-2xl text-slate-600 max-w-3xl mx-auto leading-relaxed mb-10">
                AI-powered strategic policy advisory platform for enterprises, government agencies, and institutional clients. Deliver actionable insights with precision and speed.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button className="group bg-gradient-to-r from-[#8B3A3A] to-[#6B2A2A] hover:from-[#6B2A2A] hover:to-[#8B3A3A] text-white px-12 py-7 text-lg font-bold rounded-full shadow-2xl hover:scale-105 transition-all duration-300">
                  Request Demo
                  <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
                </Button>
                <Button variant="outline" className="border-2 border-slate-300 text-slate-700 hover:bg-slate-50 px-12 py-7 text-lg font-bold rounded-full hover:scale-105 transition-all duration-300">
                  View Pricing
                </Button>
              </div>
            </div>
          </div>
        </div>

        {/* Coming Soon Section */}
        <div className="py-32 bg-white">
          <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-[#8B3A3A] to-[#6B2A2A] rounded-full mb-8">
              <Building2 className="w-10 h-10 text-white" />
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-slate-900 mb-6">
              Coming Soon
            </h2>
            <p className="text-xl text-slate-600 mb-10">
              We're building an exceptional enterprise advisory experience. Full content for the Virtual Business Policy Adviser page is under development.
            </p>
            <Link to="/">
              <Button variant="outline" className="border-2 border-slate-300 text-slate-700 hover:bg-slate-50 px-12 py-7 text-lg font-bold rounded-full hover:scale-105 transition-all duration-300">
                Back to Home
              </Button>
            </Link>
          </div>
        </div>

        <Footer />
      </div>
    </PageTransition>
  );
};

export default ProductAdvisor;
